<template>
    <div class="blufreccia">

        <section>
          <b-container>
            <b-row class="align-items-end">
              <b-col lg="12" xl="6">
                <img alt="Blufreccia Corporate" src='/img/blufreccia/Logo-Sport-Corporate.png' />
              </b-col>
              <b-col lg="12" xl="6">
                <p class="blufreccia__message">
                  Il brand e i servizi Blufreccia | sport corporate<br>
                  adesso fanno parte di Salabam srl e del servizio<br>
                  Vivamod Business.
                </p>
              </b-col>
            </b-row>
          </b-container>
        </section>

        <section data-aos="fade-up" id="scroll">
          <b-container>
            <p class="blufreccia__description">
                Se cerchi soluzioni per viaggi incentive, concorsi a premi, piano loyalty e regali aziendali con
                Vivamod Business potrai trovare soluzioni innovative e tutta la professionalità e l'attenzione che ha
                sempre caratterizzato i servizi del team <strong>Blufreccia | sport corporate.</strong>
            </p>
          </b-container>
        </section>

        <section class="blufreccia__cards mt-0 pt-0">
            <b-container>

                <div class="b-cards">

                  <div class="b-card" fluid data-aos="fade-up" @click="mixinGoTo('concorsi',{})">
                    <div class="b-card--thumb" style="background-image:url('../../../../img/home/card-1.png')"></div>
                    <div class="b-card--text">
                      <h2 class="b-card--title">Promo e concorsi</h2>
                      <p class="b-card--link">
                        Real time experience
                        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                          <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                          <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                        </svg>
                      </p>
                    </div>
                  </div>

                  <div class="b-card" fluid data-aos="fade-up" @click="mixinGoTo('incentive',{})">
                    <div class="b-card--thumb" style="background-image:url('../../../../img/home/card-2.png')"></div>
                    <div class="b-card--text">
                      <h2 class="b-card--title">Incentive al trade</h2>
                      <p class="b-card--link">
                        Viaggi incentive 4.0
                        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                          <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                          <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                        </svg>
                      </p>
                    </div>
                  </div>

                  <div class="b-card" fluid data-aos="fade-up" @click="mixinGoTo('loyalty',{})">
                    <div class="b-card--thumb" style="background-image:url('../../../../img/home/card-3.png')"></div>
                    <div class="b-card--text">
                      <h2 class="b-card--title">Piani loyalty</h2>
                      <p class="b-card--link">
                        Travel a punti
                        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                          <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                          <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                        </svg>
                      </p>
                    </div>
                  </div>

                  <div class="b-card" fluid data-aos="fade-up" @click="mixinGoTo('regali',{})">
                    <div class="b-card--thumb" style="background-image:url('../../../../img/home/card-4.png')"></div>
                    <div class="b-card--text">
                      <h2 class="b-card--title">Regali aziendali</h2>
                      <p class="b-card--link">
                        Personalizzati in scala
                        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                          <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                          <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                        </svg>
                      </p>
                    </div>
                  </div>

                  <div class="b-card" fluid data-aos="fade-up" @click="mixinGoTo('welfare',{})">
                    <div class="b-card--thumb" style="background-image:url('../../../../img/home/card-5.png')"></div>
                    <div class="b-card--text">
                      <h2 class="b-card--title">Welfare aziendale</h2>
                      <p class="b-card--link">
                        Semplice, integrato, desiderato
                        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                          <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                          <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                        </svg>
                      </p>
                    </div>
                  </div>

                </div>

                <a class="blufreccia__cards-link" href="/">Scopri di più...</a>
            </b-container>
        </section>

      <section data-aos="fade-up">
        <b-container>
          <FormContatti
              formTitle="Contattaci"
              formSubtitle="I plus delle nostre soluzioni online"
              label="form_blufreccia"
          />
        </b-container>
      </section>

    </div>
</template>

<script>
    import FormContatti from '@/components/blocks/form-contatti'
    
    export default {
        name: 'blufreccia',
        metaInfo: {
          title: 'Blufreccia - Sport Corporate',
          meta: [
            { vmid: 'metaDescription', name: 'Description', content: 'Il brand e i servizi Blufreccia | sport corporate adesso fanno parte di Salabam srl e del servizio Vivamod Business.' },
            { vmid: 'dcDescription', name: 'DC.description', lang: 'it', content: 'Il brand e i servizi Blufreccia | sport corporate adesso fanno parte di Salabam srl e del servizio Vivamod Business.' },
            { vmid: 'ogTitle', property: 'og:title', content: 'Blufreccia - Sport Corporate' },
            { vmid: 'ogDescription', name: 'og:description', content: 'Il brand e i servizi Blufreccia | sport corporate adesso fanno parte di Salabam srl e del servizio Vivamod Business.' },
          ],
        },
        components: {
            FormContatti,
        },
        data()
        {
          return {
          }
        },
        methods: {
        },
        mounted()
        {
        }
    }
</script>

<style lang="scss">
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/mixins";
    @import './../../scss/_custom.scss';

    .blufreccia {
      padding-top: 150px;
      color: $black;

      &__message {
        font-weight: 700;
        line-height: 35px;
        margin-bottom: 0;
        margin-top: 50px;
        text-align: center;

        @include media-breakpoint-up(lg)
        {
          margin-top: 0;
          text-align: left;
        }
      }

      &__description {
        font-weight: 500;
        line-height: 35px;
      }

      &__cards {

        &-link {
          text-decoration: underline;
          font-weight: 400;
          float: right;
          margin-top: 50px;
        }
      }
    }
</style>